import driverTractorIconLight from '@assets/CustomIcons/driverTractor.svg'
import driverTractorIconDark from '@assets/CustomIcons/driverTractorDark.svg'
import driverTrailerIconLight from '@assets/CustomIcons/driverTrailer.svg'
import driverTrailerIconDark from '@assets/CustomIcons/driverTrailerDark.svg'
import { useThemeContext } from '@gravitate-js/excalibrr'

type TruckIconProps = {
  size?: number
  className?: string
  style?: React.CSSProperties
}

export function TrailerIcon({ size = 16, className, style }: TruckIconProps) {
  const { isDarkTheme } = useThemeContext()
  return (
    <img
      src={isDarkTheme ? driverTrailerIconDark : driverTrailerIconLight}
      alt={'Trailer Icon'}
      style={{ height: size, ...style }}
      data-testid='trailer-icon'
      className={className}
    />
  )
}

export function TractorIcon({ size = 16, className, style }: TruckIconProps) {
  const { isDarkTheme } = useThemeContext()

  return (
    <img
      src={isDarkTheme ? driverTractorIconDark : driverTractorIconLight}
      alt={'Tractor Icon'}
      style={{ height: size, ...style }}
      data-testid='tractor-icon'
      className={className}
    />
  )
}
